import { COMPONENT_TYPE as TYPE, UNIFORM_PROPS } from 'common/constants';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View, { AnswerProgressType } from './AnswerProgress';

export const ANSWER_PROGRESS = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.ANSWER_PROGRESS,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: ANSWER_PROGRESS.displayName,
					selectable: true,
					draggable: true,
					expandable: false,
					expanded: false,
				},
				nodeProps: {
					id: generateNodeId(_id, ANSWER_PROGRESS.displayName),
				},
				componentProps: {
					[UNIFORM_PROPS.answerProgressType]: AnswerProgressType.num,
					styles: {},
					other: {},
				},
			},
			children: [],
		},
	};
};

ANSWER_PROGRESS.displayName = 'AnswerProgress';
